import React from "react";
import PropTypes from "prop-types";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Toolbar from "@mui/material/Toolbar";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import AppBar from "@mui/material/AppBar";

import { ButtonUI, KMKDialog } from "../../../Common";

const ConfirmSavePopup = ({ loading, idKey, scheduleKey, handleConfirmSaveClose, job }) => {
  const handleClickNoBtn = () => handleConfirmSaveClose({ [scheduleKey]: 0 });
  const handleClickYesBtn = () => handleConfirmSaveClose({ [scheduleKey]: 1 });
  const handleClose = () => handleConfirmSaveClose({ [idKey]: "", [scheduleKey]: "" });

  return (
    <KMKDialog onClose={handleClose} maxWidth="md" open={true}>
      <Backdrop sx={{ backgroundColor: "transparent", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="primary" />
      </Backdrop>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar
          sx={{
            fontSize: "1.1rem",
            backgroundColor: "white",
            color: "black",
          }}
        >
          Next Job Schedule
        </Toolbar>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", right: 8, top: 8, color: "black" }}
        >
          <CloseIcon />
        </IconButton>
      </AppBar>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          "{job}" has an active schedule. Apart from this chain, the selected job will also run at the scheduled time.
          Do you want to disable the scheduler for it?
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ paddingRight: "20px" }}>
        <ButtonUI variant="contained" color="success" style={{ marginLeft: 15 }} onClick={handleClickYesBtn}>
          Yes
        </ButtonUI>
        <ButtonUI onClick={handleClickNoBtn} variant="contained" size="medium" color="secondary">
          No
        </ButtonUI>
      </DialogActions>
    </KMKDialog>
  );
};

ConfirmSavePopup.propTypes = {
  job: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  handleConfirmSaveClose: PropTypes.func.isRequired,
  scheduleKey: PropTypes.oneOf(["activeSchedule", "errorSchedule", "alternateJobSchedule"]).isRequired,
  idKey: PropTypes.oneOf(["nextJobId", "errorJobId", "alternateJobId"]).isRequired,
};

export default React.memo(ConfirmSavePopup);
